import React, { useEffect } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    Box,
    ModalFooter,
    ModalBody,
    Button,
    useDisclosure,
    FormControl,
    FormLabel,
    Input,
    ModalCloseButton,
    Flex,
  } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'



export const Fundraiser_2 = () => {
const[hospitall,sethospital]=React.useState({})
const[hospital1,sethospital1]=React.useState([0])

function handlechangee(el){
sethospital({...hospitall,
[el.target.type]:el.target.value,
})
sethospital1(hospital1+1)
console.log(hospitall)
}

    // function InitialFocus() {
        const { isOpen, onOpen, onClose } = useDisclosure()
      
        const initialRef = React.useRef(null)
        const finalRef = React.useRef(null)
      
  useEffect(() => {
    onOpen();
  }, []);
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/",{replace:true})
  }
  const handleNext = () => {
    navigate("/step3",{replace:true})
  }
        return (
          <>
            {/* <Button onClick={onOpen}>Open Modal</Button> */}
            {/* <Button ml={4} ref={finalRef}>
              I'll receive focus on close
            </Button> */}
      
            <Modal
              initialFocusRef={initialRef}
              finalFocusRef={finalRef}
              isOpen={isOpen}
              onClose={onClose}
            >
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Tell us more about your patient</ModalHeader><hr/>
                <ModalCloseButton onClick={handleClose} />
                <ModalBody pb={15}>
                    {/* <Box>Raising funds for <span style={{color:'black',fontWeight:'bold'}}>Medical Treatement </span> purpose</Box> */}
                    {/* <Box style={{color:'rgb(1,191,189)'}}>Change purpose</Box><br/> */}



                  <FormControl>
                    {/* <FormLabel>First name</FormLabel> */}
                    <Input type={'name'} onChange={handlechangee} placeholder="Patient's full name" />
                  </FormControl>
      
                  <FormControl mt={4}>
                    {/* <FormLabel>Last name</FormLabel> */}
                    <Flex>
                    <Input placeholder="Patient's age" />
                    <select  type={'age'} onChange={handlechangee} variant="flushed">
                      <option> <img  style={{height:'1rem'}} src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXGIVPYYul-MWaGepeMmOL7A6_awFcVUzVnQ&usqp=CAU'/></option>
                        <option>Below 5 years</option>
                        <option>6-10 years</option>
                        <option>11-17 years</option>
                        <option>18-30 years</option>
                        <option>30-40 years</option>
                        <option>Above 40 years</option>



                     

                    </select>
                    </Flex>
                  </FormControl>

                  <FormControl mt={4}>
                    {/* <FormLabel>Last name</FormLabel> */}
                    <Box>
                    <Flex>
                    <Input type='search' placeholder="Ailment/Medical Condition" ></Input>
                    <select  type={'condition'} onChange={handlechangee} variant="flushed">
                      <option>                    <img  style={{height:'1rem'}} src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXGIVPYYul-MWaGepeMmOL7A6_awFcVUzVnQ&usqp=CAU'/>
</option>
                        <option>Accident</option>
                        <option>Aromegaly</option>
                        <option>Achalasia cardia</option>
                     

                    </select>
                    </Flex>
                    </Box>
                  </FormControl><br/>

                  <FormControl  mt={4}>
                    <Flex>
                        <input type={'status'} onChange={handlechangee} placeholder='Hospitailistion status'/><br/>
                    </Flex>

                  </FormControl>

                  
                  <FormControl  mt={4}>
                    <Flex>
                        <input placeholder='Hospital'/>
                        <select type={'hospital'} onChange={handlechangee} variant="flushed">
                        <option>Global Hospital,chennai</option>
                        <option>Apollo Hospital,Mumbai</option>
                        <option>Apollo Hospital,Delhi</option>
                        <option>Bl kapur Hospital,Delhi</option>
                        


                    </select> 
                    </Flex>

                  </FormControl>

                  
                  <FormControl  mt={4}>
                    <Flex>
                        <input placeholder='Enter your City'/><br/>
                        <select  type={'city'} onChange={handlechangee} variant="flushed">
                        <option>Delhi</option>
                        <option>Mumbai</option>
                        <option>Kolkatta</option>
                        <option>Goa</option>

                     

                    </select>
                    </Flex>

                  </FormControl>
                                    
                    
                
                 
                </ModalBody>
      
                <ModalFooter>
                  <Button disabled={hospital1==0} style={{width:'100%'}} background='rgb(1,191,189)'  colorScheme='white' onClick={handleNext}>
                    Save and continue
                  </Button>
                  {/* <Button onClick={onClose}>Cancel</Button> */}
                </ModalFooter>
              </ModalContent>
            </Modal>
          </>
        )
    
 }
